import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'

const endpoints = (baseURL => {
  return {
    getMessagesTotalQueued: `${baseURL}/api/messages/totalqueued`
  }
})(process.env.BESMTPPLUS_URL)

/**
 * @typedef {Object} GetMessagesTotalQueuedResponseGetMessagesTotalQueuedResponse
 * @property {number} TotalCount Total messages in the queue
 * @property {number} TotalBytes Total bytes of messages in the queue
 */

/**
 * @description Retrieves the TotalCount and TotalBytes values from the Frequency_Counter table
 * @returns {GetMessagesTotalQueuedResponseGetMessagesTotalQueuedResponse} x
 */
export const beSMTPPlusGetMessagesTotalQueued = () => {
  const url = endpoints.getMessagesTotalQueued
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}
